import { render, staticRenderFns } from "./MenuOfgroupManage.vue?vue&type=template&id=0611b4d1&scoped=true&"
import script from "./MenuOfgroupManage.vue?vue&type=script&lang=js&"
export * from "./MenuOfgroupManage.vue?vue&type=script&lang=js&"
import style0 from "./MenuOfgroupManage.vue?vue&type=style&index=0&id=0611b4d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0611b4d1",
  null
  
)

export default component.exports